<template>
  <div class="appointment-accept" v-if="appointment">
    <template v-if="!isSubmitted">
      <LoginForm
        v-if="!user"
        :code="appointmentNumber"
        :fio="client.fio"
        :email="client.email"
        :is-new-user="!appointment.is_user_registered"
        @register="acceptAppointment"
        @login="checkDifferenceProps"
      />

      <div
        v-else
        class="appointment-accept__request"
      >
        <div class="header">
          <p class="is-title">Новая запись к нотариусу</p>
          <p>
            Вы зарегистрировали заявку на сайте нотариуса
            <span class="link"><!-- TODO: link --></span>. Пожалуйста, проверьте
            данные и подтвердите запись.
          </p>
        </div>

        <AppointmentRequest
          :appointment="appointment"
          :partner="partner"
          :user="client"
          type="new"
        />

        <div class="attention">
          <div class="header">
            <p class="is-title">Обратите внимание</p>
            <p>
              Некоторые введённые вами личные данные не совпадают с данными в
              вашем аккаунте. Проверьте и замените их при необходимости.
            </p>
          </div>
          <div class="attention-table">
            <Row
              type="flex"
              :gutter="20"
              align="middle"
              class="attention-table__header"
            >
              <Col :lg="10">
                Данные в заявке
              </Col>
              <Col :lg="14">
                Данные из аккаунта
              </Col>
            </Row>
            <Row
              type="flex"
              :gutter="20"
              align="middle"
              class="attention-table__body"
              v-for="(item, index) in getRequestDifference()"
              :key="index"
            >
              <Col
                :lg="10"
                :class="{ 'text--red': item.request !== item.current }"
              >
                <v-icon
                  v-if="item.request !== item.current"
                  name="error"
                />
                <span>{{ item.request }}</span>
              </Col>
              <Col :lg="10">{{ item.current }}</Col>
              <Col :lg="4" class="text--center">
                <v-icon
                  v-if="item.request === item.current"
                  name="check"
                />
                <v-button
                  v-else
                  text="Заменить"
                  size="xs"
                  @click="changeClientParamValue(item.key, item.request)"
                />
              </Col>
            </Row>
          </div>
          <p class="attention__message">
            Данные, которые вы не заменили, автоматически обновятся в вашем
            аккаунте.
          </p>

          <Row type="flex" justify="center" :gutter="20">
            <Col>
              <v-button
                @click="acceptAppointment"
                text="Подтвердить"
              />
            </Col>
            <Col>
              <v-button
                color="red"
                text="Удалить заявку"
                @click="cancelAppointment"
              />
            </Col>
          </Row>
          <Row
            v-if="error"
            type="flex"
            justify="center"
            :gutter="20"
          >
            <Col class="error">{{ error }}</Col>
          </Row>


        </div>
      </div>
    </template>

    <div
      v-else
      class="appointment-accept__status"
    >

      <p class="is-title">
        {{ submitType === "accept" ? "Заявка отправлена" : "Заявка удалена" }}
      </p>

      <div
        v-if="submitType === 'accept'"
        class="status-info"
      >
        <p>Ожидайте подтверждения встречи нотариусом.</p>
        <p>
          Подтверждение будет направлено вам по электронной почте. Также вы
          можете управлять вашими заявками и отслеживать их статус в личном
          кабинете.
        </p>
      </div>

      <v-button
        text="Войти в кабинет"
        class="m-t-20"
        size="md"
        fluid
        @click="$router.push('/')"
      />
    </div><!-- END: .appointment-accept__status -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import AppointmentService from "@/services/AppointmentService";
import loadingMixin from "@/mixins/loadingMixin";
import AppointmentRequest from "@/components/AppointmentRequest";
import LoginForm from "@/components/LoginForm";
import VButton from "@/components/VButton";
import VIcon from "@/components/VIcon";


export default {
  name: "AcceptAppointment",

  components: {
    AppointmentRequest,
    VButton,
    LoginForm,
    VIcon
  },

  mixins: [
    loadingMixin,
  ],

  data() {
    return {
      service: new AppointmentService(),
      appointment: null,
      //user: mockUser,
      submitType: '',
      isSubmitted: false,

      error: '',
    };
  },

  computed: {
    ...mapGetters({
      user: "user/getUser"
    }),

    appointmentNumber() {
      return this.$route.query.code;
    },

    client() {
      return this.appointment.client;
    },

    partner() {
      return this.appointment.notary;
    }
  },

  watch: {
    user(val) {
      if (val) {
        this.checkDifferenceProps();
      }
    }
  },

  async mounted() {
    this.loading = true;

    try {
      this.appointment = await this.service.getAppointmentToAccept(
        this.appointmentNumber
      );

      if (this.user) {
        this.checkDifferenceProps();
      }
    }
    catch (err) {
      console.warn(err);
    }
    this.loading = false;
  },

  methods: {
    async acceptAppointment() {
      this.error = '';

      try {
        await this.appointment.confirmAppointment();
        this.submitType = "accept";
        this.isSubmitted = true;
      }
      catch (err) {
        this.error = 'Ошибка: не удалось подтвердить запись'
        console.error(err);
      }
    },

    async cancelAppointment() {
      this.error = '';

      try {
        await this.appointment.cancelAppointment();
        this.submitType = "cancel";
        this.isSubmitted = true;
      }
      catch (err) {
        this.error = 'Ошибка: не удалось отменить запись'
        console.error(err);
      }
    },

    getRequestDifference() {
      let keys = ["fio", "email", "phone"];
      return keys.map(key => ({
        key,
        request: this.client[key],
        current: this.user[key]
      }));
    },

    async checkDifferenceProps() {
      this.loading = true;
      let differenceProps = this.getRequestDifference();
      let check = differenceProps.every(el => el.request === el.current);
      if (check) {
        await this.acceptAppointment();
      }
      this.loading = false;
    },

    changeClientParamValue(key, value) {
      let config = {
        fio: this.user.fio,
        phone: this.user.phone,
        email: this.user.email
      };
      config[key] = value;
      this.user.editProfile(config);
    },

  },  // end: methods
};
</script>

<style scoped lang="scss">
.appointment-accept {
  display: flex;
  min-height: 100vh;
  justify-content: center;

  &__request {
    max-width: 800px;
    width: 100%;
    margin: 40px auto;
    padding: 80px;
    box-sizing: border-box;
    background: $white;

    .header {
      text-align: center;
      margin: 0 50px 40px;

      .is-title {
        margin-bottom: 20px;
      }
    }
  }

  &__status {
    max-width: 520px;
    margin: auto;
    padding: 80px;
    box-sizing: border-box;
    background: $white;

    .is-title {
      margin-bottom: 40px;
    }
  }

  .status-info {
    line-height: 1.3rem;
  }
}

.attention {
  padding-top: 40px;
  border-top: solid 1px $gray-lighter;

  &__message {
    margin: 40px 0;
  }

  .error {
    margin: 8px 0;
    color: red;
  }
}

.attention-table {
  &__header {
    color: $gray-dark;
    background: $blue-light;
    min-height: 40px;
  }

  &__body {
    min-height: 90px;
    border-bottom: solid 1px $gray-lighter;

    .text--red {
      display: flex;
      align-items: center;

      img {
        margin-right: 10px;
      }
    }
  }
}
</style>
